import React from 'react'
import Card from './styled-components/Card'
import HeaderText from './styled-components/HeaderText'
import HeaderTextSmall from './styled-components/HeaderTextSmall'
import { AnovaLogoSmall } from './AnovaLogo'
import TextColumn from './styled-components/TextColumn'
import { analyticsPage } from '../analytics'

const VerifyEmailFailure = () => {
  analyticsPage('ALI Log In - Email Verification Failure')

  return (
    <Card data-email-confirmation-failed>
      <div>
        <AnovaLogoSmall />
      </div>

      <TextColumn>
        <HeaderText>Oops! We weren't able to<br />confirm your email.</HeaderText>
        <HeaderTextSmall>Something went wrong or the link<br />you used has expired.</HeaderTextSmall>
      </TextColumn>

    </Card>
  )
}

export default VerifyEmailFailure
